import axios from 'axios';

export const getRetoolEmbedUrlAnalytics = async () =>
  await axios.get(`${process.env.REACT_APP_API_URL}retool-embed/analytics`);

export const getRetoolEmbedUrlPartnerDashboard = async () =>
  await axios.get(
    `${process.env.REACT_APP_API_URL}retool-embed/partner-dashboard`,
  );
